import React from 'react';
import { useFormikContext } from 'formik';
import {
  GradientTypes,
  LP_BUILDER_FORM_MODE,
  LpBuilderFormMode,
} from '../../constants';
import { ILandingPageDesignBase } from '../../types';
import { FormikImageUpload } from 'lib/components/formik/FormikImageUpload/FormikImageUpload';
import { FormSection } from './shared/FormSection';
import { FormContainer } from './shared/FormContainer';
import { FormikSwitchField } from 'lib/components/formik/FormikSwitchField';
import { useCovideoTheme } from 'react-covideo-common';
import { FormikDropdownField } from 'lib/components/formik/FormikDropdown';
import { ILandingPageBuilderBulkEditFormData } from '../../helpers/getInitialLandingPageValuesForBulkEdit';

interface IImageForm {
  mode: LpBuilderFormMode;
}

export const ImageForm = ({ mode }: IImageForm) => {
  const themes = useCovideoTheme();
  const { values, setFieldValue } = useFormikContext<
    ILandingPageDesignBase | ILandingPageBuilderBulkEditFormData
  >();
  const isBulkEditMode = mode === LP_BUILDER_FORM_MODE.BULK_EDIT;

  const gradientOptions = isBulkEditMode
    ? [{ value: null, label: 'None' }, ...GradientTypes]
    : GradientTypes;

  const handleShowGradientOverlayChange = () => {
    const newValue = values.showGradient ? 0 : 1;
    // if we are in bulk edit mode, set the gradient to null to avoid showing values in changes summary
    if (isBulkEditMode && newValue === 0) {
      setFieldValue('gradient', null);
    }
    setFieldValue('showGradient', newValue);
  };

  return (
    <FormContainer title='Image'>
      <FormSection title='Background Image'>
        <FormikImageUpload
          name='bodyBackgroundImage'
          extendStyles={{
            containerStyles: { height: '145px' },
            imageStyles: { width: '100%', objectFit: 'cover' },
          }}
          aspectRatio={16 / 9}
          useCropper={false}
        />
      </FormSection>
      <FormSection title='Gradient Overlay'>
        <FormikSwitchField
          name='showGradient'
          label='Gradient Overlay'
          extendStyles={{
            labelStyles: {
              fontSize: '15px',
              lineHeight: '24px',
              fontWeight: 500,
              color: themes.colors.neutral[100],
            },
          }}
          onChange={handleShowGradientOverlayChange}
        />
        {!!values.showGradient ? (
          <FormikDropdownField name='gradient' options={gradientOptions} />
        ) : (
          <></>
        )}
      </FormSection>
    </FormContainer>
  );
};
